import React from 'react'
import { PageProps } from 'gatsby'
import { Layout, Seo } from '~/components'

import { Partnership } from '~/containers'

const PartnershipPage = (props: PageProps) => (
    <Layout activePage="Partnership" joinUs>
        <Seo title="Partnership" />
        <Partnership {...props} />
    </Layout>
)

export default PartnershipPage
